import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { Redirect } from 'react-router'

import { isLoggedIn } from "utils";


export default (WrappedComponent) => {
  class withoutAuth extends React.Component {



    render() {
      return isLoggedIn() ?
        (
          <Redirect to={'/dashboard'}/>
        ) :
        (
          <WrappedComponent {...this.props} />
        );
    }
  }

  hoistNonReactStatic(withoutAuth, WrappedComponent);

  return withoutAuth;
}